<div class="row">
  <div class="col-lg-12">
    <div class="info-page">
      <h3>{{ actionLabel }} Capacidade de Execução</h3>
    </div>

    <form [formGroup]="form" (ngSubmit)="salvar()">
      <div class="form-group row m-b">
        <div class="col-sm-3">
          <label class="col-sm-12 pb-1">Possui equipe definida para execução do projeto</label>
          <ng-select class="ng-select-alternative" [items]="equipeReadyList" bindLabel="label" bindValue="id"
            formControlName="equip_ready">
          </ng-select>
          <app-field-message [field]="fieldMessageRequired('equip_ready')"
            [erros]="fieldErros('equip_ready')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-sm-8">
          <label class="col-sm-12 pb-1">Órgãos públicos envolvidos</label>
          <textarea id="ds_agency" class="form-control" formControlName="ds_agency" maxlength="1000" rows="4"
            placeholder="Ministério, Secretaria, Município, Empresa Pública, entre outros, que façam parte do Projeto"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_agency')"
            [erros]="fieldErros('ds_agency')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-sm-8">
          <label class="col-sm-12 pb-1">Organizações parceiras</label>
          <textarea id="ds_organization" class="form-control" formControlName="ds_organization" maxlength="1000"
            rows="4"
            placeholder="Universidades, empresas, ONGs, Associações que contribuirão com algum tipo de recurso (humano, espaço físico, equipamentos, etc.)."></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_organization')"
            [erros]="fieldErros('ds_organization')"></app-field-message>
        </div>
      </div>

      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-danger m-r-xxl" *ngIf="idProjeto && permissoes.canDelete" (click)="confirmExcluir()"
            type="button">Excluir</button>
          <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
          <button class="btn btn-white m-r-xs" *ngIf="idProjeto" type="button" (click)="imprimir()">Imprimir</button>
          <button class="btn btn-white m-r-xs" *ngIf="idProjeto && permissoes?.canClone" type="button" (click)="openCloneModal()">Clonar</button>
          <button *ngIf="permissoes.canSave" class="btn btn-primary" type="submit">Salvar</button>
        </div>
      </div>
    </form>
    <app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>

<ng-template #modalClone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Clonar processo</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Novo Nome</label>
        <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
      </div>
    </div>
  </div>
</ng-template>